export const defaultStyle = {
    wrapper: "relative w-full flex flex-col items-center justify-center pb-[20px] lg:h-[560px] xlg:h-[920px] bg-beige",
    bgWrapper: "w-full h-[300px] lg:h-full lg:absolute lg:top-0 lg:left-0",
    image: "w-full h-full object-cover object-center",
    heroCardWrapper: "section-wrapper self-end -mt-[70px] md:-mt-[50px] lg:self-auto lg:mt-0 z-[20]",
    heroCardContainer: "relative w-full mx-auto md:max-w-[700px] lg:max-w-[600px] lg:mx-0",
    waveMobile: "w-full lg:hidden",
    waveDesktop: "w-full hidden lg:block",
}
